export const SITE = {
  nameBN: "রাজেন্দ্রলাল স্ট্রিট সাধারণ দুর্গোৎসব কমিটি",
  shortBN: "রাজেন্দ্রলাল স্ট্রিট",
  subBN: "সাধারণ দুর্গোৎসব কমিটি",
  nameEN: "Rajendralal Street Sadharan Durgotsab Committee",
  theme: "বুনট",
  themeFull: "বুনট — আদি ও নবের মেলবন্ধন",
  year: 2026,
  est: 1943,
  yearsOfTradition: 83,
  addressBN: "১৩/ডি, রাজেন্দ্রলাল স্ট্রিট, কলকাতা ৭০০০০৬",
  addressEN: "13/D, Rajendralal Street, Kolkata 700006",
  landmark: "Chalormi Sangha",
  quote:
    "শুধু প্রতিমার আরাধনা নয়, মানুষের মধ্যে ভালোবাসার বন্ধনই হোক আমাদের দুর্গোৎসবের প্রকৃত পরিচয়।",
  phones: ["9051933331", "9831226377"],
  whatsapp: ["9051933331", "8240544727"],
  email: "rlsdurgapuja1943.connect@gmail.com",
  facebook: "https://www.facebook.com/share/1D4KTC9xZ4/",
  instagram: "https://www.instagram.com/rajendralalstreetdurgapuja",
  donationPhones: ["9051933331", "9831226377"],
  mapUrl: "https://www.google.com/maps/search/?api=1&query=Rajendralal+Street+Kolkata+700006",
};

export const COUNTDOWN_TARGET = new Date("2026-10-16T08:30:00+05:30");

export const bnNum = (s) =>
  String(s).replace(/[0-9]/g, (d) => "০১২৩৪৫৬৭৮৯"[Number(d)]);

export const HISTORY = [
  "কলকাতার অলিগলিতে শরতের হাওয়া যখন শিউলির গন্ধ বয়ে আনে, ঢাকের আওয়াজে যখন শহরের হৃদয় জেগে ওঠে, তখন রাজেন্দ্রলাল স্ট্রিটও সেজে ওঠে তার চিরচেনা উৎসবের সাজে। সেই উৎসবের সঙ্গে জড়িয়ে আছে আট দশকেরও বেশি সময়ের স্মৃতি, আবেগ, ঐতিহ্য এবং অসংখ্য মানুষের ভালোবাসা।",
  "১৯৪৩ সালে যে শুভ পথচলার সূচনা, ২০২৬-এ তা পূর্ণ করেছে গৌরবময় ৮৩ বছর। এই দীর্ঘ পথচলা শুধুমাত্র একটি দুর্গাপুজোর ইতিহাস নয়; এটি একাধিক প্রজন্মের একসঙ্গে বেড়ে ওঠার ইতিহাস। পুরনো দিনের স্মৃতি থেকে আজকের আধুনিক সময় — প্রজন্মের পর প্রজন্ম ধরে মা দুর্গার আরাধনাকে কেন্দ্র করে গড়ে উঠেছে এক নিবিড় সামাজিক বন্ধন।",
  "সময় বদলেছে, শহর বদলেছে, উৎসবের আয়োজনের ধরন বদলেছে। কিন্তু বদলায়নি মা দুর্গার প্রতি বিশ্বাস, মানুষের প্রতি ভালোবাসা এবং একসঙ্গে পথ চলার সেই চিরন্তন মানসিকতা।",
  "আমাদের কাছে দুর্গোৎসব মানে শুধুমাত্র চার দিনের আনন্দ নয়। দেবীর আরাধনার পাশাপাশি মানুষের পাশে দাঁড়ানোও আমাদের দায়িত্ব। সেই ভাবনা থেকেই বছরের পর বছর ধরে রক্তদান শিবির আয়োজন এবং দুঃস্থ ও অসহায় মানুষের মধ্যে শাল ও বস্ত্র বিতরণের মতো সমাজসেবামূলক উদ্যোগ গ্রহণ করে আসছে কমিটি। কারণ, মা দুর্গার আরাধনার সবচেয়ে সুন্দর প্রকাশ হয় মানুষের মুখে হাসি ফোটানোর মধ্যেই।",
  "এই ৮৩ বছরের পথচলায় যাঁরা প্রত্যক্ষ ও পরোক্ষভাবে আমাদের পাশে থেকেছেন — কমিটির প্রাক্তন ও বর্তমান সদস্যবৃন্দ, স্থানীয় বাসিন্দা, শুভানুধ্যায়ী, দাতা, স্বেচ্ছাসেবক এবং অসংখ্য ভক্ত — তাঁদের সকলের অবদানেই আজকের এই ঐতিহ্য।",
  "রাজেন্দ্রলাল স্ট্রিটের দুর্গোৎসব তাই শুধুই একটি পুজো নয় — এ এক উত্তরাধিকার। যে উত্তরাধিকার প্রজন্মের হাত ধরে প্রজন্মে পৌঁছে যায়। যে উত্তরাধিকার আমাদের শিকড়ের কথা মনে করিয়ে দেয়। যে উত্তরাধিকার শেখায় — উৎসব তখনই সার্থক, যখন তার আনন্দ সবার।",
  "আজ ৮৩ বছরের দোরগোড়ায় দাঁড়িয়ে আমাদের একটাই প্রার্থনা — মায়ের আশীর্বাদে অটুট থাকুক আমাদের ঐক্য, অক্ষুণ্ণ থাকুক আমাদের ঐতিহ্য, আর মানুষের পাশে থাকার এই অঙ্গীকার প্রজন্ম থেকে প্রজন্মান্তরে বয়ে চলুক। মা আসেন প্রতি শরতে, আর সঙ্গে নিয়ে আসেন ভালোবাসা, শক্তি ও একতার বার্তা। জয় মা দুর্গা। শুভ শারদীয়া।",
];

export const HISTORY_EN = [
  "When the autumn breeze carries the scent of shiuli through Kolkata's lanes, when the beat of the dhak wakes the city's heart, Rajendralal Street dresses up in its age-old festive glory. Woven into that festival are eight decades of memories, emotions, tradition, and the love of countless people.",
  "The auspicious journey that began in 1943 completes a glorious 83 years in 2026. This long journey is not merely the history of a Durga Puja; it is the story of generations growing up together. From the memories of old days to today's modern times — generation after generation, the worship of Maa Durga has held together a deep social bond.",
  "Times have changed, the city has changed, the ways of celebration have changed. But what has never changed is faith in Maa Durga, love for people, and that eternal spirit of walking the path together.",
  "For us, Durgotsab is not merely four days of joy. Alongside worshipping the Goddess, standing beside people is our duty. From that belief, year after year, the committee organises blood donation camps and distributes shawls and clothes among the distressed and helpless. Because the most beautiful expression of worshipping Maa Durga is bringing a smile to someone's face.",
  "Everyone who has stood beside us, directly or indirectly, through these 83 years — former and present committee members, local residents, well-wishers, donors, volunteers and countless devotees — today's heritage belongs to all of them.",
  "Rajendralal Street's Durgotsab is therefore not just a puja — it is a legacy. A legacy that passes from generation to generation, hand to hand. A legacy that reminds us of our roots. A legacy that teaches — a festival is truly meaningful only when its joy belongs to everyone.",
  "Standing at the doorstep of 83 years, we have only one prayer — may our unity remain unbroken by Maa's blessing, may our tradition stay intact, and may this promise of standing beside people carry on from generation to generation. Maa comes every autumn, bringing with her the message of love, strength and togetherness. Jai Maa Durga. Shubho Sharodiya.",
];

export const SCHEDULE = [
  {
    id: "mahalaya",
    bn: "মহালয়া",
    en: "Mahalaya",
    date: "2026-10-10",
    dateBN: "১০ই অক্টোবর, শনিবার",
    dateEN: "October 10, Saturday",
    tithiBN: "২২শে আশ্বিন · দেবীপক্ষের শুভ সূচনা",
    tithiEN: "22 Ashwin · The auspicious beginning of Devipaksha",
    rituals: [
      { time: "ভোরে", timeEN: "At dawn", text: "অগ্রহায়ণের শেষে মহালয়া — আকাশপ্রদীপ ও চণ্ডীপাঠের দিন। দেবীর আগমনী সুর শোনা যায় প্রতিটি বাড়িতে।", textEN: "At the end of Agrahayan comes Mahalaya — the day of akash-pradip and Chandi recitation. The Goddess's agamani songs fill every home." },
    ],
  },
  {
    id: "shashthi",
    bn: "ষষ্ঠী",
    en: "Maha Shashthi",
    date: "2026-10-16",
    dateBN: "১৬ই অক্টোবর, শুক্রবার",
    dateEN: "October 16, Friday",
    tithiBN: "২৮শে আশ্বিন · ষষ্ঠী রাত্রি ৩:৪৭ পর্যন্ত",
    tithiEN: "28 Ashwin · Shashthi tithi until 3:47 AM",
    rituals: [
      { time: "সকাল ৮:৩০-এর মধ্যে", timeEN: "By 8:30 AM", text: "দুর্গাদেবীর ষষ্ঠ্যাদি কল্পারম্ভ ও ষষ্ঠীবিহিত পূজো প্রশস্তা", textEN: "Kalparambha of Shashthi and completion of the Shashthi-ordained puja" },
      { time: "সায়ংকালে", timeEN: "In the evening", text: "দেবীর বোধন, আমন্ত্রণ এবং অধিবাস", textEN: "Bodhon, Amantran and Adhibas of the Goddess" },
    ],
  },
  {
    id: "saptami",
    bn: "সপ্তমী",
    en: "Maha Saptami",
    date: "2026-10-17",
    dateBN: "১৭ই অক্টোবর, শনিবার",
    dateEN: "October 17, Saturday",
    tithiBN: "২৯শে আশ্বিন · সপ্তমী আহোরাত্র",
    tithiEN: "29 Ashwin · Saptami all day and night",
    rituals: [
      { time: "সকাল ৭:০৪-এ", timeEN: "At 7:04 AM", text: "নবপত্রিকা প্রবেশ, স্থাপন, সপ্তমাদি কল্পারম্ভ", textEN: "Nabapatrika entry, sthapana, Saptamadi kalparambha" },
      { time: "সন্ধ্যায়", timeEN: "In the evening", text: "দেবীর আরতি", textEN: "Aarti of the Goddess" },
    ],
  },
  {
    id: "ashtami",
    bn: "সপ্তমী",
    en: "Maha Saptami",
    date: "2026-10-18",
    dateBN: "১৮ই অক্টোবর, রবিবার",
    dateEN: "October 18, Sunday",
    tithiBN: "৩০শে আশ্বিন",
    tithiEN: "30 Ashwin",
    rituals: [
      { time: "প্রাতঃ ৫:৫৩ মধ্যে", timeEN: "By 5:53 AM", text: "সপ্তমীবিহিত অধিক পূজো প্রশস্তা", textEN: "Completion of the additional Saptami-ordained puja" },
      { time: "সন্ধ্যায়", timeEN: "In the evening", text: "দেবীর আরতি", textEN: "Aarti of the Goddess" },
    ],
  },
  {
    id: "maha-ashtami",
    bn: "অষ্টমী",
    en: "Maha Ashtami",
    date: "2026-10-19",
    dateBN: "১৯শে অক্টোবর, সোমবার",
    dateEN: "October 19, Monday",
    tithiBN: "১লা কার্তিক · মহাষ্টমী সকাল ৭:৫০ পর্যন্ত",
    tithiEN: "1 Kartik · Maha Ashtami until 7:50 AM",
    rituals: [
      { time: "সকাল ৭:২৬-এ", timeEN: "At 7:26 AM", text: "সন্ধি পূজো আরম্ভ", textEN: "Sandhi Puja begins" },
      { time: "সকাল ৭:৫০-এ", timeEN: "At 7:50 AM", text: "বলিদান", textEN: "Bolidan" },
      { time: "সকাল ৮:১৪-এর মধ্যে", timeEN: "By 8:14 AM", text: "সন্ধি পূজো সামপন", textEN: "Sandhi Puja concludes" },
      { time: "সন্ধ্যায়", timeEN: "In the evening", text: "দেবীর আরতি", textEN: "Aarti of the Goddess" },
    ],
  },
  {
    id: "navami",
    bn: "নবমী",
    en: "Maha Navami",
    date: "2026-10-20",
    dateBN: "২০ই অক্টোবর, মঙ্গলবার",
    dateEN: "October 20, Tuesday",
    tithiBN: "২রা কার্তিক · মহানবমী সকাল ৯:৩১ পর্যন্ত",
    tithiEN: "2 Kartik · Maha Navami until 9:31 AM",
    rituals: [{ time: "সন্ধ্যায়", timeEN: "In the evening", text: "দেবীর আরতি", textEN: "Aarti of the Goddess" }],
  },
  {
    id: "dashami",
    bn: "দশমী",
    en: "Vijaya Dashami",
    date: "2026-10-21",
    dateBN: "২১শে অক্টোবর, বুধবার",
    dateEN: "October 21, Wednesday",
    tithiBN: "৩রা কার্তিক · দশমী দিবা ১০:৪৭ পর্যন্ত",
    tithiEN: "3 Kartik · Dashami until 10:47 AM",
    rituals: [
      { time: "সকাল ৮:৩১ মধ্যে", timeEN: "By 8:31 AM", text: "দেবীর দশমীবিহিত", textEN: "Dashami-ordained puja of the Goddess" },
      { time: "পূজো সামপনান্তে", timeEN: "After puja concludes", text: "বিসর্জন প্রশস্তা", textEN: "Bisarjan preparation" },
      { time: "বিসর্জন শেষে", timeEN: "After bisarjan", text: "দর্পণ বিসর্জন শেষে অপরাজিতা পূজো", textEN: "Darpan bisarjan followed by Aparajita puja" },
    ],
    omens: [
      { text: "দেবীর ঘোটকে আগমন", textEN: "The Goddess arrives on an elephant", fal: "ফল — ছত্রভঙ্গ", falEN: "Omen — chhatra-bhanga (upheaval)" },
      { text: "দেবীর নৌকায় গমন", textEN: "The Goddess departs by boat", fal: "ফল — শস্য ও জল বৃদ্ধি", falEN: "Omen — abundance of crops and rain" },
    ],
  },
];

export const MARQUEE_ITEMS = [
  { bn: "শুভ দুর্গাপুজো", en: "Shubho Durga Puja" },
  { bn: "ঢাকের আওয়াজ", en: "The Beat of the Dhak" },
  { bn: "আলপনা ও আরতি", en: "Alpona & Aarati" },
  { bn: "সপরিবারে আমন্ত্রণ", en: "All Are Invited" },
  { bn: "জয় মা দুর্গা", en: "Jai Maa Durga" },
  { bn: "শুভ শারদীয়া ২০২৬", en: "Shubho Sharodiya 2026" },
  { bn: "৮৩ বছরের ঐতিহ্য", en: "83 Years of Legacy" },
];

export const POST_TYPES = {
  photo: { label: "ফটো অ্যালবাম", labelEN: "Photo Album", icon: "image" },
  video: { label: "ভিডিও", labelEN: "Video", icon: "video" },
  announcement: { label: "ঘোষণা", labelEN: "Announcement", icon: "megaphone" },
  event: { label: "ইভেন্ট", labelEN: "Event", icon: "calendar" },
  document: { label: "ডকুমেন্ট / পিডিএফ", labelEN: "Document / PDF", icon: "file" },
  cultural: { label: "সাংস্কৃতিক অনুষ্ঠান", labelEN: "Cultural Programme", icon: "music" },
  puja: { label: "পূজো সংক্রান্ত", labelEN: "Puja Update", icon: "flower" },
};

export const gcalLink = (day) => {
  const start = day.date.replace(/-/g, "");
  const d = new Date(day.date + "T00:00:00Z");
  d.setUTCDate(d.getUTCDate() + 1);
  const end = d.toISOString().slice(0, 10).replace(/-/g, "");
  const text = encodeURIComponent(`${day.bn} — ${SITE.nameBN}`);
  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${text}&dates=${start}/${end}&location=${encodeURIComponent(SITE.addressEN)}`;
};
